export const medicalSpecializations = [
    { id: 1, name: 'Allergy and Immunology' },
    { id: 2, name: 'Anesthesiology' },
    { id: 3, name: 'Cardiology' },
    { id: 4, name: 'Cardiovascular Surgery' },
    { id: 5, name: 'Child Psychiatry' },
    { id: 6, name: 'Colorectal Surgery' },
    { id: 7, name: 'Critical Care Medicine' },
    { id: 8, name: 'Dentistry' },
    { id: 9, name: 'Dermatology' },
    { id: 10, name: 'Diabetology' },
    { id: 11, name: 'Emergency Medicine' },
    { id: 12, name: 'Endocrinology' },
    { id: 13, name: 'ENT (Otolaryngology)' },
    { id: 14, name: 'Family Medicine' },
    { id: 15, name: 'Gastroenterology' },
    { id: 16, name: 'General Medicine' },
    { id: 17, name: 'General Surgery' },
    { id: 18, name: 'Geriatric Medicine' },
    { id: 19, name: 'Gynecologic Oncology' },
    { id: 20, name: 'Hematology' },
    { id: 21, name: 'Hepatology' },
    { id: 22, name: 'Infectious Disease' },
    { id: 23, name: 'Internal Medicine' },
    { id: 24, name: 'Interventional Cardiology' },
    { id: 25, name: 'Interventional Radiology' },
    { id: 26, name: 'IVF & Reproductive Medicine' },
    { id: 27, name: 'Maxillofacial Surgery' },
    { id: 28, name: 'Medical Genetics' },
    { id: 29, name: 'Medical Oncology' },
    { id: 30, name: 'Neonatology' },
    { id: 31, name: 'Nephrology' },
    { id: 32, name: 'Neurology' },
    { id: 33, name: 'Neurosurgery' },
    { id: 34, name: 'Nuclear Medicine' },
    { id: 35, name: 'Nutrition & Dietetics' },
    { id: 36, name: 'Obstetrics & Gynecology' },
    { id: 37, name: 'Occupational Medicine' },
    { id: 38, name: 'Oncology' },
    { id: 39, name: 'Ophthalmology' },
    { id: 40, name: 'Oral Surgery' },
    { id: 41, name: 'Orthodontics' },
    { id: 42, name: 'Orthopedics' },
    { id: 43, name: 'Pain Management' },
    { id: 44, name: 'Palliative Care' },
    { id: 45, name: 'Pathology' },
    { id: 46, name: 'Pediatric Cardiology' },
    { id: 47, name: 'Pediatric Gastroenterology' },
    { id: 48, name: 'Pediatric Nephrology' },
    { id: 49, name: 'Pediatric Neurology' },
    { id: 50, name: 'Pediatric Oncology' },
    { id: 51, name: 'Pediatric Orthopedics' },
    { id: 52, name: 'Pediatric Pulmonology' },
    { id: 53, name: 'Pediatric Surgery' },
    { id: 54, name: 'Pediatric Urology' },
    { id: 55, name: 'Pediatrics' },
    { id: 56, name: 'Physical Medicine & Rehabilitation' },
    { id: 57, name: 'Physiotherapy' },
    { id: 58, name: 'Plastic Surgery' },
    { id: 59, name: 'Podiatry' },
    { id: 60, name: 'Preventive Medicine' },
    { id: 61, name: 'Psychiatry' },
    { id: 62, name: 'Psychology' },
    { id: 63, name: 'Pulmonology' },
    { id: 64, name: 'Radiation Oncology' },
    { id: 65, name: 'Radiology' },
    { id: 66, name: 'Rheumatology' },
    { id: 67, name: 'Sleep Medicine' },
    { id: 68, name: 'Speech Therapy' },
    { id: 69, name: 'Spine Surgery' },
    { id: 70, name: 'Sports Medicine' },
    { id: 71, name: 'Surgical Gastroenterology' },
    { id: 72, name: 'Surgical Oncology' },
    { id: 73, name: 'Thoracic Surgery' },
    { id: 74, name: 'Transplant Surgery' },
    { id: 75, name: 'Trauma Surgery' },
    { id: 76, name: 'Urology' },
    { id: 77, name: 'Vascular Surgery' },
    { id: 78, name: 'Venereology' },
    { id: 79, name: 'Bariatric Surgery' },
    { id: 80, name: 'Cosmetic Surgery' },
    { id: 81, name: 'Hand Surgery' },
    { id: 82, name: 'Joint Replacement Surgery' },
    { id: 83, name: 'Laparoscopic Surgery' },
    { id: 84, name: 'Robotic Surgery' },
    { id: 85, name: 'Ayurveda' },
    { id: 86, name: 'Homeopathy' },
    { id: 87, name: 'Naturopathy' },
    { id: 88, name: 'Unani Medicine' },
    { id: 89, name: 'Yoga & Wellness' },
    { id: 90, name: 'Acupuncture' },
    { id: 91, name: 'Chiropractic' },
    { id: 92, name: 'Clinical Pharmacology' },
    { id: 93, name: 'Laboratory Medicine' },
    { id: 94, name: 'Transfusion Medicine' },
    { id: 95, name: 'Tropical Medicine' },
    { id: 96, name: 'Urgent Care' },
    { id: 97, name: 'Wound Care' },
    { id: 98, name: 'Dental Implants' },
    { id: 99, name: 'Endodontics' },
    { id: 100, name: 'Periodontics' },
    { id: 101, name: 'Prosthodontics' },
    { id: 102, name: 'Pediatric Dentistry' },
    { id: 103, name: 'Cosmetic Dentistry' },
    { id: 104, name: 'Optometry' },
    { id: 105, name: 'Audiology' },
    { id: 106, name: 'Clinical Psychology' },
    { id: 107, name: 'Counseling' },
    { id: 108, name: 'Sexology' },
    { id: 109, name: 'Addiction Medicine' },
    { id: 110, name: 'Adolescent Medicine' },
    { id: 111, name: 'Aerospace Medicine' },
    { id: 112, name: 'Community Medicine' },
    { id: 113, name: 'Forensic Medicine' },
    { id: 114, name: 'Medical Informatics' },
    { id: 115, name: 'Telemedicine' }
];
